// src/vocabulary/C1/unit1/content.js

const content = {
  level: "C1",
  unit: 1,
  title: "Abstract Ideas & Concepts",
  description:
    "Advanced vocabulary used to express abstract ideas such as responsibility, freedom, success, and identity.",

  explanation: [
    "This unit focuses on abstract ideas rather than physical objects.",
    "Abstract words describe concepts, values, and mental states.",
    "These words are common in discussions, essays, and debates.",
    "At C1 level, learners must understand subtle differences in meaning.",
    "For example, 'freedom' and 'independence' are related but not identical.",
    "These words are often used to express opinions and arguments.",
    "Using abstract vocabulary correctly shows advanced language ability.",
    "Try to use these words to explain ideas, not just simple facts."
  ],

  items: [
    {
      word: "freedom",
      phonetic: "/ˈfriːdəm/",
      meaning: "the absence of coercion or constraint in one's choices and actions, particularly from authoritative or oppressive forces",
      example: "Freedom of expression is essential in any democratic society."
    },
    {
      word: "responsibility",
      phonetic: "/rɪˌspɒnsəˈbɪləti/",
      meaning: "the state of being morally or legally accountable for one's conduct and its consequences",
      example: "With freedom comes responsibility."
    },
    {
      word: "identity",
      phonetic: "/aɪˈdentɪti/",
      meaning: "the set of characteristics, beliefs, and experiences that distinguish an individual or group from others",
      example: "Culture plays a significant role in shaping personal identity."
    },
    {
      word: "success",
      phonetic: "/səkˈses/",
      meaning: "the favorable achievement of a desired aim, goal, or social status through sustained effort or competence",
      example: "Success means different things to different people."
    },
    {
      word: "failure",
      phonetic: "/ˈfeɪljər/",
      meaning: "the inability to meet expected standards or achieve an intended outcome, often serving as a catalyst for learning",
      example: "Failure can be a valuable and instructive experience."
    },
    {
      word: "purpose",
      phonetic: "/ˈpɜːrpəs/",
      meaning: "the underlying intention or motivation that gives direction and meaning to an individual's actions or existence",
      example: "Many people spend years searching for a clear sense of purpose."
    }
  ]
};

export default content;
